<ng-container (scroll)="windowPosition()" *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">CUBE</h5>
                <div style="flex-grow: 1;"></div>
                <button id="add" (click)="clearCache()" class="btn btn-primary float-right mr-3">Clear All Cube Cache
                </button>
                <button id="add" (click)="addNewCube()" class="btn btn-primary float-right mr-3"> Add Cube</button>
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100" placeholder="Keywords"
                           type="text" ng-reflect-maxlength="100" ng-reflect-model="" [(ngModel)]="cubeReg">
                    <div>
                        <button id="Search" (click)="searchPCube()" class="btn btn-primary float-left">Search</button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3" *ngIf='cubeList && cubeList.length'>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Description">
                        <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="DataSource">
                        <h6 class="mb-lg-0 medium text-truncate"> DataSource </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Record Format">
                        <h6 class="mb-lg-0 medium text-truncate"> Record Format </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Data Version">
                        <h6 class="mb-lg-0 medium text-truncate"> Data Version </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let cube of cubeList;">
                <loader *ngIf='loader'></loader>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{cube.cubeCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{cube.cubeCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{cube.name}}">
                    <h6 class="mb-lg-0 text-truncate"> {{cube.name}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{cube.description}}">
                    <h6 class="mb-lg-0 text-truncate"> {{cube.description}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" *ngIf='cube.dataSourceName != undefined'
                     ngbTooltip="{{cube.dataSourceName}}">
                    <h6 class="mb-lg-0 text-truncate"> {{cube.dataSourceName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" *ngIf='cube.dataSourceName == undefined'
                     ngbTooltip="N/A">
                    <h6 class="mb-lg-0 text-truncate"> N/A </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     *ngIf="cube.recordFormatData!=undefined?true:false"
                     ngbTooltip="{{cube.recordFormatData.displayName}}">
                    <ng-container *ngIf="cube.recordFormatData.displayName!=undefined?true:false">
                        <h6 class="mb-lg-0 text-truncate"> {{cube.recordFormatData.displayName}} </h6>
                    </ng-container>
                    <ng-container *ngIf="cube.recordFormatData.displayName!=undefined?false:true"
                                  ngbTooltip="{{cube.recordFormatData.name}}">
                        <h6 class="mb-lg-0 text-truncate"> {{cube.recordFormatData.name}} </h6>
                    </ng-container>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     *ngIf="cube.recordFormatData!=undefined?false:true" ngbTooltip="None">
                    <h6 class="mb-lg-0 text-truncate"> None </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     *ngIf="cube.dataVersionType!=undefined && cube.dataVersionType == 'Static'"
                     ngbTooltip="{{cube.dataVersion | date:mediumDate}}">
                    <h6 class="mb-lg-0 text-truncate"> {{cube.dataVersion | date:mediumDate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     *ngIf="cube.dataVersionType==undefined || cube.dataVersionType == 'Dynamic'">
                    <h6 class="mb-lg-0 text-truncate"></h6>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                    <h6 class="mb-lg-0" ngb-tooltip="Click for more options" (click)=entityOps($event)>
                        <i class="fa fa-ellipsis-h" [id]="cube.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedCubeId==cube.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(cube)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li *ngIf="cube.enableCache" (click)="clearCacheForCube(cube)">
                                <i class="fa fa-pencil mr-2"></i>Clear Cache
                            </li>
                            <li (click)="removeCube(cube)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                            <li (click)="removeCubeWithDimsAndMeasures(cube)">
                                <i class="fa fa-trash mr-2"></i>Delete All
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative" [id]="cube.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedCubeId==cube.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(cube)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li *ngIf="cube.enableCache" (click)="clearCacheForCube(cube)">
                                <i class="fa fa-pencil mr-2"></i>Clear Cache
                            </li>
                            <li (click)="removeCube(cube)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                            <li (click)="removeCubeWithDimsAndMeasures(cube)">
                                <i class="fa fa-trash mr-2"></i>Delete All
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="cubeList.length == 0">
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>
            <!-- <div class="w-100 float-left p-4 grid-details" *ngIf="!(cubeList && cubeList.length)">
                            <p class="text-center m-0 w-100 medium">No Results Found</p>
                        </div> -->

            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalCubes}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='cubeList && cubeList.length' [collectionSize]="totalCubes" [rotate]="true"
                                [maxSize]="5" [pageSize]="pageSize"
                                [ellipses]="false" [boundaryLinks]="true" [(page)]="currentPage"
                                (pageChange)="onPageChange($event)" class="float-right"></ngb-pagination>
            </div>
        </div>

        <!-- ADDING OR UPDATING CUBE -->
        <div class="w-100 float-left" *ngIf='cubePage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Cube </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Cube - {{cubeData.cubeCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>

            </div>
            <div class="w-100 float-left mt-3">
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="cubeData.name" name="name"
                               placeholder=" Cube Name"
                        />
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div *ngIf='cubeData.dataSourceData' class="form-group w-100">
                        <label for="dropDown">Data Source</label>
                        <input readonly class="form-control" type="text" id="dataSource" maxlength="100"
                               [(ngModel)]="cubeData.dataSourceData.name"
                               placeholder=" Data Source Name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Description
                            <span class="text-danger medium"></span>
                        </label>
                        <textarea maxlength="350" class="form-control" rows="1" [(ngModel)]="cubeData.description"
                                  name="description" placeholder="Description (Optional)"></textarea>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 float-left" *ngIf="!isEdit">
                    <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="onSave()">Save</button>
                </div>

                <ng-container *ngIf="isEdit">
                    <div class="col-lg-6 col-md-6 float-left">
                        <div class="form-group w-100 float-left">
                            <label for="recordFormat">Record Format</label>
                            <select class="form-control light-bg" (change)="confirmChangeOfRecordFormat($event)">
                                <option value="none">None</option>
                                <option *ngFor="let record of recordList" [attr.value]='record.id'
                                        [attr.selected]="cubeData.recordFormatId == record.id ? true : null">
                                    {{record.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class='col-lg-6 col-md-6 float-left left-clear'>
                            <label for="cubeData">Data Version Type</label>
                            <select class="form-control light-bg" [(ngModel)]="dataVersionType">
                                <option ng-selected="dataVersionType=='Dynamic'" ng-value="Dynamic">Dynamic</option>
                                <option ng-selected="dataVersionType=='Static'" ng-value="Static">Static</option>
                            </select>
                        </div>
                        <div class='col-lg-6 col-md-6 float-left' *ngIf="dataVersionType=='Static'?true:false">
                            <label for="cubeData">Data Version</label>
                            <div class="form-group">
                                <div class='col-sx-8 float-left left-clear'>
                                    <input class="form-control light-bg" placeholder="YYYYMMDD" name="DataVersionDate"
                                           ngbDatepicker [(ngModel)]="dataVersionDate"
                                           #d="ngbDatepicker" readonly>
                                </div>
                                <div class="col-sx-1 float-left">
                                    <button class="iga-left form-control light-bg" (click)="d.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <input type="date" [(ngModel)]="cubeData.dataVersion" required class="form-control" placeholder="yyyymmdd" /> -->
                    </div>
                    <div class='col-lg-6 col-md-6 float-left left'>
                        <div class="w-100 float-left align-v-center">
                            <!-- <div class="checkbox checkbox-primary"> -->
                            <label for="enableCache" class="mb-0 mr-3"> Enable Cache</label>
                            <input id="enableCache" type="checkbox" [(ngModel)]="cubeData.enableCache">

                            <!-- </div> -->
                        </div>
                    </div>
                    <!-- ADDING CUBE MEASURE -->
                    <div class="w-100 float-left mt-3">
                        <div class="light-bg col-lg-12 col-md-12 float-left form-group">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss">
                                <ngb-accordion class="w-100" activeIds="{{openMeasureMapping}}">
                                    <ngb-panel id="measure" [title]="getTitle('measure')">
                                        <ng-template ngbPanelContent>
                                            <div class="w-100 float-left p-md-2 grid-details table-custom">
                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group w-100 float-left">
                                                        <label for="measure">Measure</label>
                                                        <select class="form-control float-left"
                                                                [(ngModel)]="cubeMeasureData.measureId"
                                                                (change)="onSelectMeasure($event)">
                                                            <option value="none">None</option>
                                                            <option *ngFor='let measure of measureList'
                                                                    [attr.value]='measure.id'>{{measure.name}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group w-100 float-left">
                                                        <label for="measure">Type</label>
                                                        <select class="w-100 float-left form-control"
                                                                [(ngModel)]="cubeMeasureData.measureNodeType">
                                                            <option value="ACTUAL">Actual</option>
                                                            <option value="TARGET">Target</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group w-100 float-left">
                                                        <label for="recordFormatMes">Record Format field</label>
                                                        <select class="w-100 float-left form-control"
                                                                [(ngModel)]="cubeMeasureData.recordFormatFieldId"
                                                                (change)="onSelectField($event, 'measure')">
                                                            <option value="none">None</option>
                                                            <option *ngFor="let fields of recordObject.recordFormatFieldData"
                                                                    [attr.value]='fields.id'>{{fields.displayName}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group">
                                                <button class="btn btn-primary float-left" id="addMeasureField"
                                                        (click)="addFieldForMeasure()">Add
                                                    Cube Measure
                                                </button>
                                            </div>
                                            <!-- CUBE MEASURE MAPPING TABLE -->

                                            <div class="w-100 float-left mt-3"
                                                 *ngIf="cubeMeasureDataList && cubeMeasureDataList.length > 0 ">
                                                <div class="light-bg w-100 float-left p-2 grid-details">
                                                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                                        <h6 class="mb-lg-0 medium"> Code </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Name </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Record Format Field </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Type </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Edit </h6>
                                                    </div>
                                                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                                                        <h6 class="mb-lg-0 medium"> Delete </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-100 float-left p-md-2 grid-details"
                                                 *ngFor="let cubeMeasure of cubeMeasureDataList; let i = index">

                                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeMeasure.measureData.measureCode}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeMeasure.measureData.name}} </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate"> {{cubeMeasure.recordFormatField
                                                        &&
                                                        cubeMeasure.recordFormatField.displayName?cubeMeasure.recordFormatField.displayName:""}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeMeasure.measureNodeType}} </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        <i class="fa fa-pencil mr-2" (click)="editMeasure(cubeMeasure)">
                                                            Edit
                                                        </i>
                                                    </h6>
                                                </div>
                                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        <i class="fa fa-trash mr-2"
                                                           (click)="removeCubeMeasure($event, cubeMeasure)"> Delete
                                                        </i>
                                                    </h6>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>
                    </div>

                    <!-- ADDING CUBE DIMENSION -->
                    <div class="w-100 float-left mt-3">
                        <div class="light-bg col-lg-12 col-md-12 float-left form-group">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss">
                                <ngb-accordion class="w-100" activeIds="{{openDimensionMapping}}">
                                    <ngb-panel id="dimension" [title]="getTitle('dimension')">
                                        <ng-template ngbPanelContent>
                                            <div class="w-100 float-left p-md-2 grid-details table-custom">
                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group">
                                                        <label> Mapping Name
                                                            <span class="text-danger medium">*</span>
                                                        </label>
                                                        <input maxlength="200" type="text" class="form-control"
                                                               [(ngModel)]="cubeDimensionUsageData.name"
                                                               name="mappingName" placeholder=" Mapping Name"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group w-100 float-left">
                                                        <label for="dim">Dimension</label>
                                                        <select class="form-control" id="dimcube"
                                                                [(ngModel)]="referencevariable"
                                                                (change)="onSelectDimenasion($event)">
                                                            <option value="none">None</option>
                                                            <optgroup *ngFor="let dim of dimensionList"
                                                                      label={{dim.name}}>
                                                                <option [attr.value]="dim.id+'_'+level.id"
                                                                        *ngFor="let level of dim.dimHierarchyData[0].dimHierarchyLevelData">
                                                                    {{level.displayName}}
                                                                </option>
                                                            </optgroup>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 float-left">
                                                    <div class="form-group">
                                                        <label for="recordFormatDim">Record Format field</label>
                                                        <select class="form-control"
                                                                [(ngModel)]="cubeDimensionUsageData.recordFormatFieldId"
                                                                (change)="onSelectField($event, 'dimension')">
                                                            <option value="none">None</option>
                                                            <option *ngFor="let fields of recordObject.recordFormatFieldData"
                                                                    [attr.value]='fields.id'>{{fields.displayName}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div *ngIf="emptyDimensionRecord" class="form-group w-100">
                                                    <p class="error-msg text-center"> {{errorName}} </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3 form-group">
                                                <button class="btn btn-primary float-left" id="addDimField"
                                                        (click)="addFieldForDimension()">Add
                                                    Cube Dimension
                                                </button>
                                            </div>

                                            <!-- CUBE DIMENSION MAPPING TABLE -->
                                            <div class="w-100 float-left mt-3"
                                                 *ngIf="cubeDimensionUsageList && cubeDimensionUsageList.length > 0 ">
                                                <div class="light-bg w-100 float-left p-2 grid-details">
                                                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                                        <h6 class="mb-lg-0 medium"> Code </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Mapping Name </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Dimension Name </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Dimension Level Name </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Record Format Field </h6>
                                                    </div>
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                        <h6 class="mb-lg-0 medium"> Edit </h6>
                                                    </div>
                                                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                                                        <h6 class="mb-lg-0 medium"> Delete </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-100 float-left p-md-2 grid-details"
                                                 *ngFor="let cubeDimension of cubeDimensionUsageList; let i = index">
                                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeDimension.dimensionData.dimCode}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate"> {{cubeDimension.name}} </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate"> {{cubeDimension.dimensionData ?
                                                        cubeDimension.dimensionData.name : ""}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeDimension.dimHierarchyLevelData ?
                                                        cubeDimension.dimHierarchyLevelData.displayName : ""}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        {{cubeDimension.recordFormatField.displayName}}
                                                    </h6>
                                                </div>
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        <i class="fa fa-pencil mr-2"
                                                           (click)="editDimension(cubeDimension)"> Edit
                                                        </i>
                                                    </h6>
                                                </div>
                                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                                                    <h6 class="mb-lg-0 text-truncate">
                                                        <i class="fa fa-trash mr-2"
                                                           (click)="removeCubeDimension($event, cubeDimension)"> Delete
                                                        </i>
                                                    </h6>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-2 col-md-2 float-right">
                        <button id="save " [disabled]="saveButton" (click)="onSave()"
                                class="btn btn-primary float-right">Save
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- measure-editor -->
    <measureEditor *ngIf="measurePage" [measureData]="measureData" (triggerSave)="afterSavingMeasure($event)"
                   (triggerBack)="comingBackFromMeasureScreen()"></measureEditor>
    <!-- dimension-editor -->
    <dimensionEditor *ngIf="dimensionPage" [dimensionData]="dimensionData" (triggerSave)="afterSavingDimension($event)"
                     (triggerBack)="comingBackFromDimensionScreen()"></dimensionEditor>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/cube.component.html